import { createApi } from '@reduxjs/toolkit/query/react';

import { CLAIM_API_URL } from 'api/APIBase';
import { mapClaimInsightsFields } from 'services/claimInsightsHelpers';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const mapClaim = (claim) => ({
    payerId: claim.payer_id,
    claimDateOfService: claim.claim_date_of_service,
    productServiceOid: claim.product_service_oid,
    ndc: claim.ndc,
    isBrand: claim.is_brand,
    claimId: claim.claim_id,
    prescriptionNumber: claim.prescription_number,
    quantity: claim.quantity,
    drugDaysSupply: claim.drug_days_supply,
    benefit: claim.benefit,
    assignedSupplierNpi: claim.assigned_parent_pharmacy_npi,
    billingSupplierNpi: claim.billing_parent_pharmacy_npi,
    claimStatus: claim.claim_status?.trim(),
    ...mapClaimInsightsFields(claim),
});

export const claimApi = createApi({
    baseQuery: getBaseQuery(CLAIM_API_URL),
    reducerPath: 'claimApi',
    endpoints: (build) => ({
        getClaimsForReferral: build.query({
            query: ({ payerId, referralId }) => `${payerId}/referral/${referralId}`,
            transformResponse: (response) => response?.map(mapClaim),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred fetching claim history.',
            ),
        }),
        getClaimsForMemberDrug: build.query({
            query: ({ payerId, memberId, patientDob, patientFirstName, productServiceOid }) => ({
                url: `${payerId}/member_drug`,
                params: {
                    member_id: memberId,
                    patient_dob: patientDob,
                    patient_first_name: patientFirstName,
                    product_service_oid: productServiceOid,
                },
            }),
            transformResponse: (response) => response?.map(mapClaim),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred fetching claim history.',
            ),
        }),
    }),
});

export const { useGetClaimsForReferralQuery, useGetClaimsForMemberDrugQuery } = claimApi;
